// src/react/widgets/custom-layout.tsx
import { jsxDEV } from "react/jsx-dev-runtime";
var CustomLayout = ({ widget }) => {
  return /* @__PURE__ */ jsxDEV(widget.component, {
    children: widget.children.map((child, i) => /* @__PURE__ */ jsxDEV(NovelWidgetDriver, {
      widgets: [child]
    }, `${child.type}_${child.id}_${i}`, false, undefined, this))
  }, undefined, false, undefined, this);
};
// src/react/widgets/image.tsx
import { jsxDEV as jsxDEV2 } from "react/jsx-dev-runtime";
var Image = ({ widget }) => {
  return /* @__PURE__ */ jsxDEV2("img", {
    id: widget.id,
    className: widget.style,
    src: widget.src,
    alt: widget.id
  }, undefined, false, undefined, this);
};
// src/react/widgets/layout.tsx
import { jsxDEV as jsxDEV3 } from "react/jsx-dev-runtime";
var Layout = ({ widget }) => {
  return /* @__PURE__ */ jsxDEV3("div", {
    id: widget.id,
    className: widget.style,
    children: widget.children.map((child, i) => /* @__PURE__ */ jsxDEV3(NovelWidgetDriver, {
      widgets: [child]
    }, `${child.type}_${child.id}_${i}`, false, undefined, this))
  }, undefined, false, undefined, this);
};
// src/react/widgets/text.tsx
import { jsxDEV as jsxDEV4 } from "react/jsx-dev-runtime";
var Text = ({ widget }) => {
  return /* @__PURE__ */ jsxDEV4("p", {
    id: widget.id,
    className: widget.style,
    children: widget.content
  }, undefined, false, undefined, this);
};
// src/react/widgets/text-box.tsx
import { jsxDEV as jsxDEV5 } from "react/jsx-dev-runtime";
var TextBox = ({ widget }) => {
  return /* @__PURE__ */ jsxDEV5("div", {
    id: widget.id,
    className: widget.style,
    children: widget.children.map((child, i) => /* @__PURE__ */ jsxDEV5(Text, {
      widget: child
    }, `${widget.id}_${i}`, false, undefined, this))
  }, undefined, false, undefined, this);
};
// src/react/novel-widget-driver.tsx
import { jsxDEV as jsxDEV6, Fragment } from "react/jsx-dev-runtime";
var NovelWidgetDriver = ({ widgets }) => {
  return /* @__PURE__ */ jsxDEV6(Fragment, {
    children: widgets.map((widget, i) => {
      switch (widget.type) {
        case "CustomLayout":
          return /* @__PURE__ */ jsxDEV6(CustomLayout, {
            widget
          }, `${widget.type}_${widget.id}_${i}`, false, undefined, this);
        case "Image":
          return /* @__PURE__ */ jsxDEV6(Image, {
            widget
          }, `${widget.type}_${widget.id}_${i}`, false, undefined, this);
        case "Layout":
          return /* @__PURE__ */ jsxDEV6(Layout, {
            widget
          }, `${widget.type}_${widget.id}_${i}`, false, undefined, this);
        case "TextBox":
          return /* @__PURE__ */ jsxDEV6(TextBox, {
            widget
          }, `${widget.type}_${widget.id}_${i}`, false, undefined, this);
        case "Text":
          return /* @__PURE__ */ jsxDEV6(Text, {
            widget
          }, `${widget.type}_${widget.id}_${i}`, false, undefined, this);
        default:
          return null;
      }
    })
  }, undefined, false, undefined, this);
};
export {
  TextBox,
  Text,
  NovelWidgetDriver,
  Layout,
  Image,
  CustomLayout
};

//# debugId=B6BF9E89DAA3B31864756E2164756E21
//# sourceMappingURL=index.js.map
